var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[_c('b-card',[(_vm.webMapPlotterUrl)?_c('iframe',{staticStyle:{"width":"100%","height":"700px"},attrs:{"src":_vm.webMapPlotterUrl}}):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/views/Dashboard.vue?vue&type=template&id=91d066c2&
// module id = null
// module chunks = 